/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdiscardtitle2Inputs */

const en_dropdiscardtitle2 = /** @type {(inputs: Dropdiscardtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard changes?`)
};

const de_dropdiscardtitle2 = /** @type {(inputs: Dropdiscardtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen verwerfen?`)
};

/**
* | output |
* | --- |
* | "Discard changes?" |
*
* @param {Dropdiscardtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdiscardtitle2 = /** @type {((inputs?: Dropdiscardtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdiscardtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdiscardtitle2(inputs)
	return de_dropdiscardtitle2(inputs)
});
export { dropdiscardtitle2 as "dropDiscardTitle" }